<template>
  <div class="page-checklist card">
    <h3 v-if="title" class="page-checklist-title">{{ title }}</h3>
    <ul class="page-checklist-list">
      <li v-for="(item, i) in items" :key="i">
        <span class="page-checklist-box" aria-hidden="true">☐</span>
        {{ item }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'PageChecklist',
  props: {
    title: {
      type: String,
      default: 'Checklist',
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
